export function registerSpaceNormalizer(Quill: any) {
  class SpaceNormalizer {
    private quill: any;
    private normalizing = false;

    constructor(quill: any) {
      this.quill = quill;

      // Patch getSemanticHTML so ngx-quill (HTML format) always receives clean output
      const originalGetSemanticHTML = quill.getSemanticHTML.bind(quill);
      quill.getSemanticHTML = (...args: any[]) => {
        const html = originalGetSemanticHTML(...args);
        return typeof html === "string" ? html.replace(/&nbsp;|\u00A0/g, " ") : html;
      };

      // Patch getText so ngx-quill (text format) always receives clean output
      const originalGetText = quill.getText.bind(quill);
      quill.getText = (...args: any[]) => {
        const text = originalGetText(...args);
        return typeof text === "string" ? text.replace(/\u00A0/g, " ") : text;
      };

      // Normalize DOM text nodes on content changes (keeps DOM clean for copy-paste, etc.)
      quill.on("text-change", () => {
        if (this.normalizing) return;
        this.normalizeSpaces();
      });

      // Normalize initial content (e.g. loaded from templates)
      setTimeout(() => this.normalizeSpaces(), 0);
    }

    private normalizeSpaces() {
      const walker = document.createTreeWalker(this.quill.root, NodeFilter.SHOW_TEXT);
      let node: Text | null;
      let needsUpdate = false;

      while ((node = walker.nextNode() as Text | null)) {
        if (node?.nodeValue?.includes("\u00A0")) {
          node.nodeValue = node.nodeValue.replace(/\u00A0/g, " ");
          needsUpdate = true;
        }
      }

      if (needsUpdate) {
        this.normalizing = true;
        this.quill.update("silent");
        this.normalizing = false;
      }
    }
  }

  Quill.register("modules/spaceNormalizer", SpaceNormalizer);
}
